import type { FieldBindingConfig } from '@wix/wix-data-client-common'
import type { FieldSpec, Schema } from '@wix/wix-data-schema-types'
import type { DataBindingComponentModel } from '@wix/data-binding-registry-sdk'
import { isValidFieldBinding } from '../../../business-logic/bindings/validation'

const isBindingCompatible = ({
  binding,
  field,
  bindingDefinition,
  role,
}: {
  binding: FieldBindingConfig
  field: FieldSpec
  bindingDefinition: DataBindingComponentModel
  role: string
}): boolean => {
  const section = bindingDefinition.sections.find(s => s.role === role)
  const propertyDef = section?.bindings.find(b => b.prop === binding.prop)

  return propertyDef ? isValidFieldBinding(field, propertyDef) : false
}

export const remapFieldBindings = (
  fieldBindings: FieldBindingConfig[],
  fieldMap: Record<string, string>,
  newSchema: Schema,
  bindingDefinition: DataBindingComponentModel,
  role: string,
) => {
  const filteredBindings = fieldBindings.filter(binding => {
    const newFieldKey = fieldMap[binding.fieldPath]
    const field = newFieldKey && newSchema.fields[newFieldKey]

    return (
      field && isBindingCompatible({ binding, field, bindingDefinition, role })
    )
  })

  return filteredBindings.map(binding => {
    const newFieldKey = fieldMap[binding.fieldPath]
    const field = newSchema.fields[newFieldKey]

    return {
      ...binding,
      fieldPath: newFieldKey,
      fieldType: field?.type,
    }
  })
}
